import { useState, useEffect, useCallback } from 'react';
import { url } from '../../../api';
import { apiClient } from '../../../api/client';
import { coffeeChainPaths } from '../../coffee_card_web/api/paths';
import { getAuthToken } from '../../../utils/authTokens';

export interface ChainRule {
    _id: string;
    chainId: string;
    field: string;
    operator: string;
    value: string;
    caseSensitive: boolean;
    isActive: boolean;
}

const authHeaders = () => ({ headers: { Authorization: `Bearer ${getAuthToken()}` } });

export function useChainRules(chainId: string | null) {
    const [rules, setRules] = useState<ChainRule[]>([]);
    const [loading, setLoading] = useState(!!chainId);
    const [error, setError] = useState<string | null>(null);

    const fetchRules = useCallback(async () => {
        if (!chainId) {
            setRules([]);
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const res = await apiClient.get(`${url}${coffeeChainPaths.rules(chainId)}`, authHeaders());
            setRules(res.data?.rules || []);
        } catch (err: any) {
            setError(err?.response?.data?.error || 'Failed to fetch rules');
            setRules([]);
        } finally {
            setLoading(false);
        }
    }, [chainId]);

    useEffect(() => {
        fetchRules();
    }, [fetchRules]);

    return { rules, loading, error, refetch: fetchRules };
}
